import React, { useMemo } from 'react';
import { bool, node, string, array, number, object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { reportContactSellerClick } from '../../../utils/contactSeller';
import ContactTrigger from '../../shared/ContactTrigger';
import { GradientBorderButton } from '../../shared/GradientBorderButton/GradientBorderButton';
import {contactSellerTabButtonStyle} from "../ContactSellerOptions/ContactButtonStyles/TabContent";
import { isInLynxesCtaReworkTest } from '../../../utils/experiments/isInLynxesCtaRework';
import { getSelectedPackageId } from '../../../reducers/packages';
import { shouldShowRequestToOrderBtn } from '../../PackagesTabs/TabContent/TabFooter/RequestToOrderBtn/utils/shouldShowRequestToOrderBtn';

const ContactSellerBtn = ({
    asContactSellerOption,
    mixpanelSourceComponent,
    bqSourceName,
    triggerId,
    triggerCopy,
    triggerPlacement,
    children,
    packageList,
    isStickyContactCTA = false,
    packageId,
}, { rollouts, gig }) => {
    const { instantOrderSettings } = gig || {};
    const { biEvents, floatingChatData } = useGigPageContext();

    const onClick = () =>
        reportContactSellerClick({
            biEvents,
            mixpanelSourceComponent,
            bqSourceName,
            metricKey: 'contact_seller.click',
        });

    const contactSellerButtonPropsTest = useMemo(() => ({
        backgroundColor: 'black',
        color: 'white',
        marginBottom: isStickyContactCTA ? '0' : '4',
        paddingX: { default: '6', sm: '0' },
    }), [isStickyContactCTA]);

    const showRequestToOrder = shouldShowRequestToOrderBtn({ instantOrderSettings, packageId, rollouts });
    const isInLynxesCtaReworkExperiment = isInLynxesCtaReworkTest(packageList || []) && !showRequestToOrder;

    return (
        <Container
            {...(isInLynxesCtaReworkExperiment
                ? { textAlign: "center", marginX:  isStickyContactCTA ? '0' : { default: "6", sm: "0" } }
                : {})}
        >
            <ContactTrigger
                className={classNames({ [contactSellerTabButtonStyle]: !isInLynxesCtaReworkExperiment })}
                source="contact-btn"
                onClick={onClick}
                bqSourceName={bqSourceName}
                triggerId={triggerId}
                triggerCopy={triggerCopy}
                triggerPlacement={triggerPlacement}
            >
                {(triggerProps) =>
                    asContactSellerOption ? (
                        <Container {...triggerProps}>{children}</Container>
                    ) : (
                        <GradientBorderButton {...triggerProps} variant="outline" fullWidth withBorder={floatingChatData?.isEligible && !isInLynxesCtaReworkExperiment}
                        withAdditionalMargin={!isInLynxesCtaReworkExperiment}
                        {...isInLynxesCtaReworkExperiment ? contactSellerButtonPropsTest : {}}
                        >
                            {children}
                        </GradientBorderButton>
                    )
                }
            </ContactTrigger>
        </Container>
    );
};

ContactSellerBtn.propTypes = {
    asContactSellerOption: bool,
    mixpanelSourceComponent: string,
    bqSourceName: string,
    children: node,
    triggerId: string,
    triggerCopy: string,
    triggerPlacement: string,
    packageList: array,
    isStickyContactCTA: bool,
    packageId: number,
};

ContactSellerBtn.contextTypes = {
    rollouts: object,
    gig: object,
};

const mapStateToProps = (state) => ({
    packageList: state.packages?.packageList || [],
    packageId: getSelectedPackageId(state),
});

export default connect(mapStateToProps)(ContactSellerBtn);